import type { ReactNode } from "react"
import { Link, usePage } from "@inertiajs/react"
import { HugeiconsIcon } from "@hugeicons/react"
import { Search01Icon } from "@hugeicons/core-free-icons"

import { cn } from "@/lib/utils"
import { Logo } from "@/components/Logo"

function AppHeaderRoot({ children }: { children: ReactNode }) {
  return (
    <header className="flex w-full items-center justify-between gap-4 py-5">
      {children}
    </header>
  )
}

function AppHeaderNav({ children }: { children: ReactNode }) {
  return <div className="flex items-center gap-5">{children}</div>
}

function AppHeaderLogo() {
  return <Logo className="text-blue-600" />
}

function AppHeaderNavLink({
  href,
  children,
}: {
  href: string
  children: ReactNode
}) {
  const { url } = usePage()
  const active = url === href || url.startsWith(`${href}/`)

  return (
    <Link
      href={href}
      className={cn(
        "font-medium",
        active ? "text-foreground" : "text-muted-foreground"
      )}
    >
      {children}
    </Link>
  )
}

function AppHeaderSearch({
  placeholder = "Search",
}: {
  placeholder?: string
}) {
  return (
    <label className="flex min-h-9 w-full max-w-80 items-center gap-2 rounded-full border border-border bg-background px-3 py-1.5 shadow-xs">
      <HugeiconsIcon
        icon={Search01Icon}
        size={16}
        className="shrink-0 text-muted-foreground"
      />
      <input
        type="search"
        placeholder={placeholder}
        className="w-full min-w-0 bg-transparent text-sm text-foreground placeholder:text-muted-foreground focus:outline-none"
      />
    </label>
  )
}

function AppHeaderActions({ children }: { children: ReactNode }) {
  return <div className="flex items-center gap-4">{children}</div>
}

export const AppHeader = {
  Root: AppHeaderRoot,
  Nav: AppHeaderNav,
  Logo: AppHeaderLogo,
  NavLink: AppHeaderNavLink,
  Search: AppHeaderSearch,
  Actions: AppHeaderActions,
}
